var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncompleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#FFEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1646_1352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5007 22.375V12.2917C26.4992 11.0267 25.4741 10.0015 24.2091 10H14.1257C14.0042 10 13.8876 10.0483 13.8017 10.1343L10.135 13.801C10.0491 13.8869 10.0007 14.0035 10.0007 14.125V29.7083C10.0022 30.9733 11.0274 31.9985 12.2924 32H24.209C25.4741 31.9985 26.4992 30.9733 26.5007 29.7083V28.7917H25.584V29.7083C25.584 30.4677 24.9684 31.0833 24.209 31.0833H12.2924C11.533 31.0833 10.9174 30.4677 10.9174 29.7083V14.3148L14.3155 10.9167H24.2091C24.9685 10.9167 25.5841 11.5323 25.5841 12.2917V22.375H26.5007Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 10.4583V13.2083C13.6667 13.4614 13.4615 13.6666 13.2084 13.6666H12.2917V14.5833H13.2084C13.9678 14.5833 14.5834 13.9676 14.5834 13.2083V10.4583H13.6667V10.4583Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8658 21.0286L30.5967 19.7594C30.4177 19.5805 30.1276 19.5805 29.9486 19.7594L22.9677 26.7403C22.7888 26.9193 22.7888 27.2094 22.9677 27.3884L24.2368 28.6575C24.3228 28.7435 24.4393 28.7918 24.5608 28.7918C24.6824 28.7918 24.7989 28.7435 24.8849 28.6575L31.8657 21.6767C32.0447 21.4977 32.0447 21.2076 31.8658 21.0286ZM24.5608 27.6854L23.9398 27.0644L30.2726 20.7316L30.8936 21.3526L24.5608 27.6854Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7499 27.8749V26.9583H22.8333V28.3333C22.8333 28.5864 23.0385 28.7916 23.2916 28.7916H24.6666V27.8749H23.7499Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2919 11.8333H22.3752V12.7499H23.2919C23.545 12.7499 23.7502 12.9551 23.7502 13.2083V14.1249H24.6669V13.2083C24.6669 12.4489 24.0513 11.8333 23.2919 11.8333Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9169 16.4167H14.5836C14.3305 16.4167 14.1252 16.622 14.1252 16.8751V23.2917C14.1249 23.467 14.2245 23.6271 14.3819 23.7042L17.5696 25.2626C17.779 25.3822 18.0159 25.4454 18.2571 25.4459C18.4846 25.4474 18.7085 25.3894 18.9066 25.2777L22.1186 23.7042C22.276 23.6271 22.3756 23.467 22.3752 23.2917V16.8751C22.3752 16.622 22.17 16.4167 21.9169 16.4167ZM21.4586 23.0057L18.4776 24.4674C18.3267 24.5497 18.1432 24.5445 17.9972 24.4536L15.0419 23.0057V17.3334H21.4585V23.0057H21.4586Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2178 18.9124L17.7918 21.3383L16.7409 20.2874L16.0928 20.9355L17.4678 22.3105C17.5537 22.3964 17.6703 22.4447 17.7918 22.4447C17.9134 22.4447 18.0299 22.3964 18.1158 22.3105L20.8658 19.5605L20.2178 18.9124Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 27.875C18.9136 27.875 18.7084 27.6698 18.7084 27.4167V26.5H17.7917V27.4167C17.7917 28.176 18.4074 28.7917 19.1667 28.7917H21.9168V27.875H19.1667Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4584 11.8333H20.5417V12.7499H21.4584V11.8333Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1646_1352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompleteIcon);
export default __webpack_public_path__ + "static/media/incompleteIcon.bdec08f349f3788c466b1c9c6fdc7b73.svg";
export { ForwardRef as ReactComponent };